import { __decorate, __metadata } from "tslib";
import { SerializableObject } from '../../decorators';
import { Acceleration } from '../../values';
import { SensorObject } from '../SensorObject';
/**
 * Accelerometer sensor provides on each reading the acceleration applied to the device along all three axes including gravity.
 * @category data
 */
let Accelerometer = class Accelerometer extends SensorObject {
  constructor(uid, value, frequency, displayName) {
    super(uid, value !== null && value !== void 0 ? value : new Acceleration(), frequency, displayName);
  }
};
Accelerometer = __decorate([SerializableObject(), __metadata("design:paramtypes", [String, Acceleration, Number, String])], Accelerometer);
export { Accelerometer };